import React, { useState } from 'react';
import { auth } from '../../services/api';

interface LoginPageProps {
  onLogin: (token: string) => void;
}

export function LoginPage({ onLogin }: LoginPageProps) {
  const [email, setEmail] = useState('admin@demo.com');
  const [password, setPassword] = useState('admin123');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await auth.login(email, password);
      localStorage.setItem('access_token', res.access_token);
      localStorage.setItem('user_email', res.email);
      localStorage.setItem('user_role', res.role);
      localStorage.setItem('tenant_id', res.tenant_id);
      // Sincronizar rol en el store para que los componentes reaccionen
      const { setCurrentUserRole } = (await import('../../store')).useAppStore.getState();
      setCurrentUserRole(res.role);
      onLogin(res.access_token);
    } catch {
      setError('Credenciales inválidas. Verifica tu email y contraseña.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--color-background-tertiary)',
    }}>
      <div style={{
        width: 380, padding: '40px 36px',
        background: 'var(--color-background-primary)',
        borderRadius: 16,
        border: '1px solid var(--color-border-tertiary)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
      }}>
        {/* Logo */}
        <div style={{ marginBottom: 32, display: 'flex', justifyContent: 'center' }}>
          <img src='logo_bassp.jpg' />
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: 'var(--color-text-secondary)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{
                width: '100%', padding: '10px 14px', borderRadius: 8,
                border: '1px solid var(--color-border-secondary)',
                background: 'var(--color-background-secondary)',
                color: 'var(--color-text-primary)', fontSize: 14,
                boxSizing: 'border-box', outline: 'none',
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: 'var(--color-text-secondary)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{
                width: '100%', padding: '10px 14px', borderRadius: 8,
                border: '1px solid var(--color-border-secondary)',
                background: 'var(--color-background-secondary)',
                color: 'var(--color-text-primary)', fontSize: 14,
                boxSizing: 'border-box', outline: 'none',
              }}
            />
          </div>

          {error && (
            <div style={{
              marginBottom: 16, padding: '10px 14px', borderRadius: 8,
              background: '#FCEBEB', border: '1px solid #F7C1C1',
              color: '#791F1F', fontSize: 13,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '12px', borderRadius: 10,
              border: 'none',
              background: loading ? 'var(--color-border-secondary)' : '#3B8BD4',
              color: '#fff', fontSize: 14, fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s',
            }}
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        <div style={{ marginTop: 24, padding: 14, borderRadius: 10, background: 'var(--color-background-secondary)', fontSize: 12, color: 'var(--color-text-secondary)' }}>
          <div style={{ marginBottom: 32, display: 'flex', justifyContent: 'center' }}>
            <img src='ba_international_logo.jpg' />
          </div>
          <div style={{ fontWeight: 600, marginBottom: 6, color: 'var(--color-text-primary)' }}>Cuentas de demo:</div>
          <div>admin@demo.com / admin123</div>
          <div>tester@demo.com / tester123</div>
        </div>
      </div>
    </div>
  );
}